import IconButton from '@mui/material/IconButton';
import Tooltip from '@mui/material/Tooltip';
import Chip from '@mui/material/Chip';
import AnchorIcon from '@mui/icons-material/Anchor';
import LayersIcon from '@mui/icons-material/Layers';
import { useMapStore } from '@shared/hooks/useMapStore';

export function PortsToggle() {
  const portsVisible = useMapStore((s) => s.portsVisible);
  const togglePorts = useMapStore((s) => s.togglePorts);

  return (
    <Tooltip title={portsVisible ? 'Hide ports' : 'Show ports'}>
      <IconButton
        size="small"
        onClick={togglePorts}
        color={portsVisible ? 'primary' : 'default'}
        aria-label="Toggle ports"
      >
        <AnchorIcon fontSize="small" />
      </IconButton>
    </Tooltip>
  );
}

export function AvcsToggle() {
  const avcsMode = useMapStore((s) => s.avcsMode);
  const toggleAvcsMode = useMapStore((s) => s.toggleAvcsMode);

  return (
    <Tooltip title={`Switch to ${avcsMode === 'products' ? 'cells' : 'products'} view`}>
      <Chip
        icon={<LayersIcon />}
        label={avcsMode === 'products' ? 'AVCS: Products' : 'AVCS: Cells'}
        size="small"
        variant="outlined"
        onClick={toggleAvcsMode}
        sx={{ cursor: 'pointer' }}
      />
    </Tooltip>
  );
}
